import PlayerCard from './PlayerCard'
export default PlayerCard
